<template>
  <div>
    <b-table
      :fields="historyFields"
      :items="paginatedHistories"
      class="table-bordered table-hover col-md-8 p-2"
    >
      <template v-slot:cell(detail)="row">
        <div
          class="orderCode"
          @click="viewHistoryDetail(row.item)"
          style="cursor: pointer; color: #3699ff"
        >
          <span>Chi tiết</span>
        </div>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="totalHistories"
      :per-page="perPage"
      aria-controls="historyTable"
      align="center"
    ></b-pagination>
  </div>
</template>

<style lang="scss" scoped>
@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>

<script>
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SideBar } from '@/core/config/menu/sideBar';
import { ORDER_STATUS, ORDER_HISTORY_ACTION_CONST } from '@/utils/constants';
import moment from 'moment';
import ApiService from '@/core/services/api.service';

export default {
  props: ['orderId'],
  data() {
    return {
      histories: [],
      currentPage: 1,
      perPage: 10,
      totalHistories: 0,
      historyFields: [
        { key: 'creator', label: 'Người thao tác', thStyle: { textAlign: 'left', width: '30%' }, formatter: value => value.fullName },
        { key: 'action', label: 'Hành động', sortable: false, thStyle: { textAlign: 'left', width: '30%' }, formatter: value => ORDER_HISTORY_ACTION_CONST.find(x => x.value === value)?.text || 'Không xác định' },
        { key: 'createdAt', label: 'Thời gian', sortable: false, thStyle: { textAlign: 'left', width: '30%' } },
        { key: 'detail', label: '', sortable: false, thStyle: { textAlign: 'left', width: '10%' } },
      ],
    };
  },
  computed: {
    paginatedHistories() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.histories.slice(start, start + this.perPage);
    },
  },
  mounted() {
    this.$store.dispatch(SET_MENU, SideBar.ORDER);
  },
  created() {
    if (this.orderId) {
      this.fetchOrderHistory(this.orderId);
    }
  },
  methods: {
    async fetchOrderHistory(orderId) {
      const params = { orderId, getFull: true };
      try {
        const response = await ApiService.query('/order-histories', { params });
        this.histories = response.data.data.map(item => {
          const data = {
            ...item,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            updatedAt: moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
          };

          [data.originalValue, data.newValue].forEach(element => {
            if (element?.status) {
              const listStatus = ORDER_STATUS.filter(x => !x.checked).map(x => ({ ...x, value: Number(x.value) }));
              element.statusName = listStatus.find(x => x.value === Number(element.status))?.text || null;
            }
          });
          return data;
        });
        this.totalHistories = this.histories.length;
      } catch (error) {
        console.error('Lỗi khi tải lịch sử đơn hàng:', error);
      }
    },
    viewHistoryDetail(item) {
      const { href } = this.$router.resolve({ name: 'detail-order-history', query: { id: item.id } });
      window.open(href, '_blank');
    },
  },
};
</script>
